import { motion } from "framer-motion";
import { RuneLogo } from "@/components/RuneLogo";

export const ChatMessage = ({ role, content, streaming = false }) => {
  const isUser = role === "user";
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
      className={`flex w-full gap-3 ${isUser ? "justify-end" : "justify-start"}`}
      data-testid="chat-message"
      data-role={role}
    >
      {!isUser && (
        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[color:var(--rb-border)] bg-[color:var(--rb-surface)]">
          <RuneLogo className="h-4 w-4" />
        </div>
      )}
      <div
        className={`max-w-[85%] whitespace-pre-wrap break-words rounded-2xl px-4 py-3 text-sm leading-relaxed ${
          isUser
            ? "rounded-tr-md border border-[color:rgba(45,212,191,0.22)] bg-[color:rgba(45,212,191,0.12)] text-[color:var(--rb-text)]"
            : "rounded-tl-md border border-white/10 bg-white/[0.04] text-[color:var(--rb-text)]"
        }`}
      >
        {content}
        {streaming && <span className="rb-caret ml-0.5 inline-block h-4 w-[7px] translate-y-0.5 rounded-sm bg-[color:var(--rb-accent)]" />}
      </div>
    </motion.div>
  );
};
